const INITIAL_STATE = {
  inboundStorageProducts: []
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'SET_INBOUND_STORAGE_PRODUCTS': {
      return { ...state, inboundStorageProducts: action.inboundStorageProducts };
    }
    default:
      return state;
  }
};
